import { render } from "./SalesRepDetails.vue?vue&type=template&id=070a012f&scoped=true"
import script from "./SalesRepDetails.vue?vue&type=script&lang=js"
export * from "./SalesRepDetails.vue?vue&type=script&lang=js"

import "./SalesRepDetails.vue?vue&type=style&index=0&id=070a012f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070a012f"]])

export default __exports__